/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import PropTypes from 'prop-types'
import { Button, Col, Row } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { Pagination, Navigation } from 'swiper/modules'
import CIIcon from './CIIcon'

function CarouselPreview({
  srcs,
  boldTexts,
  contentTexts,
  btnTexts,
  redirectUrl,
}) {
  const validImages = Array.isArray(srcs) ? srcs.filter((src) => src.file) : []

  return (
    <div className="scroller-hide">
      {validImages.length > 0 && (
        <Swiper
          modules={[Pagination, Navigation]}
          slidesPerView={1.25}
          spaceBetween={0}
          centeredSlides
          // loop={validImages.length > 2}
          id="swiper-carousel"
          className="w-100 mx-auto swiper-container"
          navigation={{ enabled: true }}
        >
          {validImages.map((src, idx) => {
            let imageSrc
            if (src.file instanceof File) {
              imageSrc = URL.createObjectURL(src.file)
            } else if (
              typeof src.file === 'string' &&
              src.file.startsWith('blob:')
            ) {
              imageSrc = src.file
            } else {
              imageSrc = `/api/file/${src.file}`
            }
            return (
              <SwiperSlide key={idx}>
                <div
                  role="presentation"
                  style={{
                    width: '100%',
                    height: '12rem',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '0px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (redirectUrl) window.open(redirectUrl, '_blank')
                  }}
                >
                  <CIIcon bottom="96%" right="5%" />
                  <img
                    className="d-flex"
                    src={imageSrc}
                    alt={src.label}
                    style={{
                      objectFit: 'cover',
                      width: '90%',
                      height: '100%',
                      borderRadius: '0px',
                    }}
                  />
                </div>
                <div
                  className="border"
                  style={{
                    width: '90%',
                    height: '100%',
                    borderRadius: '0px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Row className="mx-0">
                    <Col
                      xs={12}
                      className="d-flex px-1 text-start text-dark overflow-hidden py-1 fw-bold App-oneLineEllipsis"
                    >
                      <div style={{ fontSize: '11px' }}>
                        {boldTexts[idx] || '預設標題'}
                      </div>
                    </Col>
                  </Row>
                  <Row className="mx-0 py-1">
                    <Col
                      xs={8}
                      className="d-flex px-1 text-start text-dark overflow-hidden small App-oneLineEllipsis"
                      style={{ fontSize: '10px' }}
                    >
                      {contentTexts[idx] || '預設內文'}
                    </Col>
                    <Col xs={4} className="d-flex overflow-hidden px-0">
                      <Button
                        size="sm"
                        variant="carousel"
                        className="ms-auto me-1 App-oneLineEllipsis"
                      >
                        {btnTexts[idx] || '按鈕文字'}
                      </Button>
                    </Col>
                  </Row>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      )}
    </div>
  )
}

CarouselPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  boldTexts: PropTypes.arrayOf(PropTypes.string),
  contentTexts: PropTypes.arrayOf(PropTypes.string),
  btnTexts: PropTypes.arrayOf(PropTypes.string),
  redirectUrl: PropTypes.arrayOf(PropTypes.string),
}

CarouselPreview.defaultProps = {
  srcs: [],
  boldTexts: [],
  contentTexts: [],
  btnTexts: [],
  redirectUrl: [],
}

export default CarouselPreview
